import reportWebVitals from './reportWebVitals';
import {InitialISearchPanelModule} from "./bootstrap/initialISearchPanelModule";


// Делаем глобальную переменную в window, чтобы использовать её снаружи
(window as any).ISearchWidgetFactory = {
    create: () => new InitialISearchPanelModule(),
};


/**
 *
 *      Инициализация скрипта
 *
 *      const iSearchPanelModule = (window).ISearchWidgetFactory.create();
 *       iSearchPanelModule.setApiChannel('dev_ifp_en')
 *       // iSearchPanelModule.setExcludeFilterFiled(['ws_available_for_sale_by_firm'])
 *       //
 *       // iSearchPanelModule.setFilterParams({
 *       //   'ws_available_for_sale_by_firm': ['33']
 *       // })
 *
 *       iSearchPanelModule.render("_isp-root-page");
 *       iSearchPanelModule.destroy("_isp-root-page");
 */


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
